import {ResellerAgencyRestService} from './restServices';
import storageService from '../storageService';
import utilsService from '../utilsService';

var service = {};

service.createResellerAgency = async (name, contactEmail) => {
  const token = storageService.getItem('token');
  const response = await ResellerAgencyRestService.save(
    {},
    {
      name,
      contactEmail,
      token,
    },
  );

  utilsService.logApiResponse('createResellerAgency', response.data);
  return response.data;
};

service.getAllResellerAgencies = async () => {
  const token = storageService.getItem('token');
  const response = await ResellerAgencyRestService.get({}, {token});

  utilsService.logApiResponse('getAllResellerAgencies', response.data);
  return response.data;
};

service.getResellerAgencyByResellerAgencyId = async (resellerAgencyId) => {
  const token = storageService.getItem('token');
  const response = await ResellerAgencyRestService.get(
    {endpoint: 'resellerAgencyId', endpointParam: resellerAgencyId},
    {token},
  );

  utilsService.logApiResponse(
    'getResellerAgencyByResellerAgencyId',
    response.data,
  );
  return response.data;
};

service.updateResellerAgency = async (resellerAgencyDto) => {
  const token = storageService.getItem('token');
  const response = await ResellerAgencyRestService.update(
    {},
    {
      resellerAgencyDto,
      token,
    },
  );

  utilsService.logApiResponse('updateResellerAgency', response.data);
  return response.data;
};

service.deleteResellerAgency = async (resellerAgencyId) => {
  const token = storageService.getItem('token');
  const response = await ResellerAgencyRestService.delete(
    {endpoint: resellerAgencyId},
    {token},
  );

  utilsService.logApiResponse('deleteResellerAgency', response.data);
  return response.data;
};

service.getPublicResellerAgencyByHostname = async (hostname) => {
  const response = await ResellerAgencyRestService.get(
    {
      endpoint: 'public/hostname',
      endpointParam: hostname,
    },
    {},
  );

  utilsService.logApiResponse(
    'getPublicResellerAgencyByHostname',
    response.data,
  );
  return response.data;
};

const resellerAgencyService = {...service};
export default resellerAgencyService;
